// Teletel: error reporting is OFF unless the server hands the page a DSN
// (window.errorLoggingConfig) — which privacy mode never does in production.
// The Sentry SDK is only downloaded when a DSN is present, so the ~170 KB it
// weighs never reaches ordinary users. Call sites keep using the familiar
// `Sentry.captureException` / `Sentry.setContext` names through this module;
// without a DSN they are cheap no-ops.
let sentry = null;
let loading = null;

export const isErrorReportingEnabled = () => Boolean(window.errorLoggingConfig);

const DENY_URLS = [
  // Chrome extensions
  /^chrome:\/\//i,
  /chrome-extension:/i,
  /extensions\//i,
  // Locally saved copies
  /file:\/\//i,
  // Safari extensions.
  /safari-web-extension:/i,
  /safari-extension:/i,
];

// Loads and initialises Sentry only when a DSN is configured. Safe to call
// unconditionally from an entrypoint; resolves to null when reporting is off.
export const initErrorReporting = ({ app, router }) => {
  if (!isErrorReportingEnabled()) return Promise.resolve(null);
  if (loading) return loading;

  loading = import('@sentry/vue')
    .then(module => {
      module.init({
        app,
        dsn: window.errorLoggingConfig,
        denyUrls: DENY_URLS,
        integrations: [module.browserTracingIntegration({ router })],
        ignoreErrors: [
          'ResizeObserver loop completed with undelivered notifications',
        ],
      });
      sentry = module;
      return module;
    })
    .catch(() => null);
  return loading;
};

export const captureException = (...args) => {
  if (sentry) sentry.captureException(...args);
};

export const setContext = (...args) => {
  if (sentry) sentry.setContext(...args);
};
